import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  connect() {
    const header = document.body.querySelector('.main-nav')
    const headerHeight = header?.offsetHeight || 0
    document.documentElement.style.setProperty('--screen-height', `${window.innerHeight - headerHeight}px`)
  }
}
